import axios from 'axios'
import store from '@/store'

const notificationsClient = axios.create({})

notificationsClient.interceptors.request.use(config => {
    config.headers.Authorization = `Bearer ${store.getters['auth/getToken']}`
    config.headers.lang = store.getters['getLang']
    config.url = `${process.env.VUE_APP_PROTOCOL}://${store.getters['auth/getTenantHost']}/notifications/api/v1${config.url}`
    return config;
})

export default notificationsClient